export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7588.51d36b8c.jpg";